import PropTypes from 'prop-types';

import { Typography } from '@mui/material';

const BreadcrumbItem = (props) => {
  const { color, text } = props;

  return (
    <Typography component="h1" variant="h5" color={color} sx={{ maxWidth: 'initial !important' }}>
      {text}
    </Typography>
  );
};

BreadcrumbItem.propTypes = {
  color: PropTypes.string,
  text: PropTypes.string
};

export default BreadcrumbItem;
